import { AppConfigService } from './app-config.service';

export function initializeAppConfig(appConfigService: AppConfigService) {
    console.log('load app config file');
    return () => appConfigService.load();
}
